export default "__VITE_ASSET__CEVLn56K__"